import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import {
  IPagination,
  IPaginationMeta,
} from '@ib-shared/interfaces/pagination.intf';
import { ITableConfig } from '@ib-shared/interfaces/table-config.intf';
import { DATA_TYPE } from '@ib-shared/types/data.type';
import { map, takeUntil } from 'rxjs/operators';

import { DashboardFacadeService } from '../../services/dashboard-facade.service';
import { DASHBOARD_TABLE_CONFIG } from './table-config';

@Component({
  selector: 'ib-dashboard-transactions',
  templateUrl: './dashboard-transactions.component.html',
  styleUrls: ['./dashboard-transactions.component.scss'],
})
export class DashboardTransactionsComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public loading$ = this.dashboardFacadeS.selectIsTableRowsLoading();
  public dataSource$ = this.dashboardFacadeS.selectRows().pipe(
    map(r => {
      if (r && r.data.length === 0) {
        const tc = JSON.parse(
          JSON.stringify(DASHBOARD_TABLE_CONFIG),
        ) as ITableConfig;
        const column = tc.columns.find(i => i.field === 'balance');
        column.dataType = DATA_TYPE.TEXT;
        this.tableConfig = tc;
        return new MatTableDataSource([
          {
            date: this.authFacadeS.authUser.accCreatedAt,
            description: 'Savings Account Opened',
            buyRate: 0,
            debit: 0,
            credit: 0,
            balance: '0.00' as any,
          },
        ]);
      } else {
        this.tableConfig = DASHBOARD_TABLE_CONFIG;
        this.totalItems = r?.meta?.itemCount || 0;
        const dataSource = new MatTableDataSource(r?.data || []);
        this.lastMeta = r?.meta;
        return dataSource;
      }
    }),
  );
  public displayedColumns = DASHBOARD_TABLE_CONFIG.columns.map(
    col => col.field,
  );
  private lastMeta: IPaginationMeta;
  public totalItems: number;
  public tableConfig: ITableConfig = DASHBOARD_TABLE_CONFIG;
  public DATA_TYPE = DATA_TYPE;
  sortType = 'desc'; // todo enum
  @ViewChild('paginator') paginator: MatPaginator;

  constructor(
    private authFacadeS: AuthFacadeService,
    private dashboardFacadeS: DashboardFacadeService,
    public bpS: UiBreakpointsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.dashboardFacadeS
      .fetchRows({
        order: this.sortType,
        page: 1,
        take: 25,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }

  sortChange(e: Sort): void {
    const params: IPagination = {
      page: this.lastMeta.page,
      take: 25,
    };
    if (e.active && e.direction) {
      this.sortType = e.direction;
      params.order = e.direction;
    } else {
      this.sortType = undefined;
    }
    this.dashboardFacadeS
      .fetchRows(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  changePagination(v: PageEvent): void {
    const p: IPagination = {
      page: v.pageIndex + 1,
      take: 25,
    };
    if (this.sortType) {
      p.order = this.sortType;
    }
    this.dashboardFacadeS
      .fetchRows(p)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
}
